export const messages = {
  add: { id: 'admin/promotions.form.conditions.add' },
}
